<template>
  <v-container fluid class="grey lighten-4 py-0">
    <v-row class="py-10">
      <v-col cols="12"
        class="pt-8 pb-12"
        :class="{
          'px-12': $vuetify.breakpoint.mdAndUp,
        }"
      >
        <v-row class="text-center justify-center">
          <v-col cols="auto">
            <h3 class="body-1 font-weight-regular pt-3">
              <span class="poppins primary--text">veja o que rolou nas</span>
            </h3>
            <h2 class="display-1 font-weight-medium pt-1">
              <span class="barlow black--text">TURMAS ANTERIORES</span>
            </h2>
            <v-divider class="mx-auto primary my-4" style="width: 50px; border: 2px solid"></v-divider>
          </v-col>
        </v-row>
        <v-row 
          class=""
          :class="{
            'pt-4': $vuetify.breakpoint.mdAndUp,
            'px-0 mx-0': $vuetify.breakpoint.smAndDown
          }"
        >
          <v-col 
            cols="12" md="4"
            v-for="(c,i) in cards" :key="i"
          >
            <v-sheet>
              <v-img
                :aspect-ratio="4/3"
                class="fill-height" 
                :src="getImgUrl(c.imagem)"
              ></v-img>
            </v-sheet>
          </v-col>
        </v-row>
        <v-row class="pt-6 px-4 text-center justify-center">
          <v-col cols="auto">
            <h3 class="body-1 font-weight-regular pt-3">
              <span class="poppins primary--text">Encontre sua luz. Integre sua sombra.</span>
            </h3>
            <h2 class="display-1 font-weight-medium pt-1">
              <span class="barlow black--text">E VOCÊ, vai ficar de fora da próxima turma?</span>
            </h2>
            <v-btn
              x-large outlined
              color="primary"
              class="mt-6"
              @click="$vuetify.goTo('#mais-info')"
            >
              <span class="font-weight-bold">Inscrever Agora</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      cards: [
        {
          imagem: '1.jpg',
        },
        {
          imagem: '2.jpg',
        },
        {
          imagem: '3.jpg',
        },
        {
          imagem: '4.jpg',
        },
        {
          imagem: '5.jpg',
        },
        {
          imagem: '6.jpg',
        },
      ]
    }
  },
  methods: {
    getImgUrl(i) {
      return require('../assets/img/turmas/'+i)
    },
  }
}
</script>